import styled from 'styled-components';

export const ProcessInfoContainer = styled.div`
  min-height: 100vh;
  background-color: #f8f9fa;
`;

export const InfoCard = styled.div`
  border: 1px solid #dee2e6;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
`;

export const BadgeContainer = styled.div`
  .badge {
    font-size: 0.75rem;
    padding: 0.5rem 0.75rem;
    border-radius: 4px;
  }

  .badge-success {
    background-color: #28a745;
    color: white;
  }

  .badge-warning {
    background-color: #ffc107;
    color: #212529;
  }

  .badge-danger {
    background-color: #dc3545;
    color: white;
  }

  .badge-secondary {
    background-color: #6c757d;
    color: white;
  }
`;

export const ActionButton = styled.button`
  border-radius: 8px;
  font-weight: 500;
  transition: all 0.2s ease;

  &:hover {
    transform: translateY(-1px);
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
  }
`;

export const ContactLink = styled.a`
  text-decoration: none;
  font-weight: 500;

  &:hover {
    text-decoration: underline;
  }
`;

export const LoadingContainer = styled.div`
  min-height: 60vh;
  background: #fff;
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;
